import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService, UserService } from '@app/_services';
import { CourseService } from '@app/_services/course.service';
import { first } from 'rxjs/operators';
import { InCourseNavigationComponent } from '../incourse-navigation/incourse-navigation.component';
import { NavigationProgressComponent } from '../navigation-progress/navigation-progress.component';
import { ConclusionComponent } from './conclusion/conclusion.component';
import { IntroComponent } from './intro/intro.component';
import { OverviewComponent } from './overview/overview.component';
import { PEBTopicComponent } from './peb-topic/peb-topic.component';
import { SOISectionComponent } from './soi-section/soi-section.component';
import { TopicComponent } from './topic/topic.component';

@Component({ templateUrl: 'section.component.html' })
export class SectionComponent implements OnInit {

    @ViewChild('introSection', { static: false }) introSection: IntroComponent;
    @ViewChild('topicSection', { static: false }) topicSection: TopicComponent;
    @ViewChild('overviewSection', { static: false }) overviewSection: OverviewComponent;
    @ViewChild('pebSection', { static: false }) pebSection: PEBTopicComponent;
    @ViewChild('soiSection', { static: false }) soiSection: SOISectionComponent;
    @ViewChild('conclusionSection', { static: false }) conclusionSection: ConclusionComponent;

    @ViewChild('inCourseNavigation') set inCourseNavigation(inCourseNavigation: InCourseNavigationComponent) {
        if (inCourseNavigation) {
            inCourseNavigation.onExitEvent.subscribe(() => {
                this.saveHandler();
            });
        }
    }

    @ViewChild('navigationProgress') set navigationProgress(navigationProgress: NavigationProgressComponent) {
        if (navigationProgress) {
            navigationProgress.onContinueEvent.subscribe(() => {
                this.saveAndNextSectionHandler(navigationProgress);
            });
            
        }
    }


    saveHandler() {
        switch (this.sectionType) {
            case 0:
                this.introSection.save().subscribe((progressResponse: any) => {
                    this.router.navigate(['/dashboard']);
                });
                break;
            case 1:
                this.topicSection.save().subscribe((progressResponse: any) => {
                    this.router.navigate(['/dashboard']);
                });
                break;
            case 2:
                this.pebSection.save().subscribe((progressResponse: any) => {
                    this.router.navigate(['/dashboard']);
                });
                break;
            case 3:
                this.overviewSection.save().subscribe((progressResponse: any) => {
                    this.router.navigate(['/dashboard']);
                });
                break;
            case 4:
                this.conclusionSection.save().subscribe((progressResponse: any) => {
                    this.router.navigate(['/dashboard']);
                });
                break;
            case 5:
                this.soiSection.save().subscribe((progressResponse: any) => {
                    this.router.navigate(['/dashboard']);
                });
                break;
        }
    }

    saveAndNextSectionHandler(navigationProgress) {
        switch (this.sectionType) {
            case 0:
                this.introSection.save().subscribe((progressResponse: any) => {
                    this.HandleSaveSectionResponse(progressResponse, this.router)
                });
                break;
            case 1:
                this.topicSection.save().subscribe((progressResponse: any) => {
                    this.HandleSaveSectionResponse(progressResponse, this.router)
                });
                break;
            case 2:
                this.pebSection.save().subscribe((progressResponse: any) => {
                    this.HandleSaveSectionResponse(progressResponse, this.router)
                });
                break;
            case 3:
                this.overviewSection.save().subscribe((progressResponse: any) => {
                    this.HandleSaveSectionResponse(progressResponse, this.router)
                });
                break;
            case 4:
                this.conclusionSection.save().subscribe((progressResponse: any) => {
                    this.HandleSaveSectionResponse(progressResponse, this.router)
                });
                break;
            case 5:
                this.soiSection.save().subscribe((progressResponse: any) => {
                    let nextSection = progressResponse;
                    if (Array.isArray(progressResponse)) {
                        nextSection = progressResponse.filter(r => r?.nextSectionId != null)[0];
                    }
                    this.HandleSaveSectionResponse(nextSection, this.router)
                });
                break;
        }
    }

    HandleSaveSectionResponse(progressResponse: any, router: Router) {
        this.sectionType=-1;

        if (progressResponse) {
            var nextSectionId = progressResponse.nextSectionId;
            router.navigate(['/course-section', nextSectionId.toString()]);
        } else {
            router.navigate(['/dashboard']);
        }
    }

    sectionId: any;
    sectionType: any;
    sectionsTotal: any;
    currentSection: any;
    currentSectionId: any;
    theme: any;
    localNavigationData: any;
    selectedZipCodes: any;

    constructor(private route: ActivatedRoute,
        public router: Router,
        private courseService: CourseService,
        private userService: UserService,
        private authService: AuthenticationService,
        private changeDetectorRef: ChangeDetectorRef) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            this.sectionId = params.get('id');
            this.courseService.getSectionData(this.sectionId).subscribe((response: any) => {
                this.sectionType = response.sectionType;
                this.sectionsTotal = response.sectionsTotal;
                this.currentSection = response.currentSection;
                this.currentSectionId = response.currentSectionId;
                this.theme = response.theme.toLowerCase();
                this.localNavigationData = response.localNavigationData;
            });
        });
    }
}